export { ShareModule } from './share.module';
export { ShareCopyService } from './share-copy.service';